// Calendar days as the backend writes them, YYYY-MM-DD in Zurich time: today
// in Zurich, the days before and after, and the Swiss way to show one
// (24.09.2026). Day arithmetic runs on the calendar alone, so a clock change
// never shifts it.

import { t } from "@/i18n";

const ZURICH_DATE = new Intl.DateTimeFormat("de-CH", {
  timeZone: "Europe/Zurich",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

/** The calendar day it is in Zurich at `now`. */
export function zurichToday(now: Date = new Date()): string {
  const parts = ZURICH_DATE.formatToParts(now);
  const part = (type: Intl.DateTimeFormatPartTypes): string =>
    parts.find((p) => p.type === type)?.value ?? "";
  return `${part("year")}-${part("month")}-${part("day")}`;
}

function calendarDate(day: string): Date {
  const [year, month, date] = day.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, date));
}

/** The day `days` calendar days after `day` (before it when negative). */
export function addDays(day: string, days: number): string {
  const date = calendarDate(day);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

/** 2026-09-24 → 24.09.2026. */
export function formatDay(day: string): string {
  const [year, month, date] = day.split("-");
  return `${date}.${month}.${year}`;
}

/** 2026-09-24 → «Do, 24.09.2026»: the weekday in the dashboard language. */
export function dayLabel(day: string): string {
  // getUTCDay counts from Sunday; the weekday list starts on Monday.
  const weekday = (calendarDate(day).getUTCDay() + 6) % 7;
  return `${t("weekday.short").split(",")[weekday]}, ${formatDay(day)}`;
}
